import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	modules: [],
};

export default function modulesReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.LOAD_MODULES_SUCCESS:
			return {
				...state,
				modules: action.modules,
			};
		default:
			return state;
	}
}
